import {zapi} from '../__internal__/http-client/index.js';

import * as endpoints from './endpoints.js';

/**
 * @see https://developer.zattoo.com/display/ZAPI/2.2.13+-+Editorial+Content#2.2.13-EditorialContent-page
 * @param {$ZAPI.Editorial.PageRequest} data
 * @returns {Promise<$ZAPI.Editorial.PageResponse>}
 */
export const getEditorialPage = ({pghash, public_id, ...data}) => {
    return zapi({
        path: `v2/cached/${pghash}/pages/${public_id}`,
        method: 'get',
        endpointID: endpoints.EDITORIAL_PAGE_RECEIVED,
        data,
    });
};

/**
 * @see https://developer.zattoo.com/display/ZAPI/2.2.13+-+Editorial+Content#2.2.13-EditorialContent-teasercollection
 * @param {$ZAPI.Editorial.TeaserCollectionRequest} data
 * @returns {Promise<$ZAPI.Editorial.TeaserCollectionResponse>}
 */
export const getEditorialTeasers = ({pghash, public_id, ...data}) => {
    const {filters, ...restData} = data;

    return zapi({
        path: `v2/cached/${pghash}/teaser_collections/${public_id}`,
        method: 'get',
        endpointID: endpoints.EDITORIAL_TEASERS_RECEIVED,
        data: {
            ...restData,
            ...filters,
        },
    });
};

/**
 * @see https://developer.zattoo.com/display/ZAPI/2.2.13+-+Editorial+Content#2.2.13-EditorialContent-subnavigation
 * @param {string} publicId
 * @returns {Promise<$ZAPI.Editorial.SubNavigationResponse>}
 */
export const getEditorialSubNavigation = (publicId) => {
    return zapi({
        path: `sub_navigations/${publicId}`,
        method: 'get',
        endpointID: endpoints.EDITORIAL_SUB_NAVIGATION_RECEIVED,
    });
};

/**
 * @see https://developer.zattoo.com/pages/viewpage.action?pageId=5996653#2.2.16-ExternalApps%2BContent-getexternalcontent
 * @param {$ZAPI.Editorial.ExternalContentRequest} data
 * @returns {Promise<$ZAPI.Editorial.ExternalContentTeasable>}
 */
export const getExternalContent = ({pghash, id}) => zapi({
    path: `cached/${pghash}/external/content/${id}`,
    method: 'get',
    endpointID: endpoints.EDITORIAL_EXTERNAL_CONTENT_RECEIVED,
});

/**
 * @see https://developer.zattoo.com/pages/viewpage.action?pageId=5996653#2.2.16-ExternalApps%2BContent-searchexternalcontent
 * @param {$ZAPI.Editorial.SearchExternalContentRequest} data
 * @returns {Promise<$ZAPI.Editorial.SearchExternalContentResponse>}
 */
export const searchExternalContent = ({pghash, ...data}) => {
    return zapi({
        path: `cached/${pghash}/external/content/search`,
        method: 'get',
        endpointID: endpoints.EDITORIAL_SEARCH_EXTERNAL_CONTENT_RECEIVED,
        data,
    });
};
